var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var pickerRequestState = require('../../layout/components/pickerRequestState');
var verticalListItem = require('../../components/verticalListItem');
var paginationWithSearch = require('../../data/components/paginationWithSearch');

var equipmentTree = {};

equipmentTree.oninit = function (vnode) {
  var ctrl = this;
  ctrl.startView = false;
  ctrl.selectedNode = vnode.attrs.selectedNode;
  ctrl.newNode = prop();
  ctrl.dataToShow = [];
  ctrl.recordsToExclude = vnode.attrs.recordsToExclude || [];
  pickerRequestState.initialize(ctrl);

  ctrl.getLocations = function () {
    ctrl.equipmentRecords = [];
    ctrl.actualLevel = prop('Home');
    ctrl.ancestors = prop([{ '@class': 'Home', 'name': 'Home' }]);
    ctrl.selectedNode('');  
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/',
        method: 'GET'
      })
      .then(function (result) {
        ctrl.locations = result.out_Contains && Array.isArray(result.out_Contains) ? result.out_Contains.filter(c => c.in['@class'] == 'Site').map(r=> r.in) : [];
        ctrl.equipmentRecords = result.out_isLocationOf && Array.isArray(result.out_isLocationOf) ? result.out_isLocationOf.map(isLocationOfEdge => isLocationOfEdge.in) : [];
        ctrl.equipmentRecords.forEach(r => r.isEquipment = true);
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: ctrl.getLocations, errorMessage: 'Unable to load locations for picker:' });
  }

  ctrl.navigateLocation = function (location) {
    ctrl.equipmentRecords = [];
    ctrl.startView = false;
    ctrl.actualLevel('Site');
    ctrl.ancestors([ctrl.ancestors()[0], location]);
    ctrl.selectedNode('');
    
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + location['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.buildings = res.out_isSiteOf && Array.isArray(res.out_isSiteOf) ? res.out_isSiteOf.map(isSiteOfEdge => isSiteOfEdge.in) : [];
        ctrl.equipmentRecords = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.map(isLocationOfEdge => isLocationOfEdge.in) : [];
        ctrl.equipmentRecords.forEach(r => r.isEquipment = true);
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLocation(location); }, errorMessage: 'Unable to load location children for picker:' });
  }
  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }

  ctrl.navigateBuilding = function (building) {
    ctrl.equipmentRecords = [];
    ctrl.startView = false;
    ctrl.actualLevel('Building');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], building]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + building['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.floors = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.equipmentRecords = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.map(isLocationOfEdge => isLocationOfEdge.in) : [];
        ctrl.equipmentRecords.forEach(r => r.isEquipment = true);
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateBuilding(building); }, errorMessage: 'Unable to load building children for picker:' });
  }
  
  ctrl.navigateLevel = function (level) {
    ctrl.equipmentRecords = [];
    ctrl.startView = false;
    ctrl.actualLevel('Level');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], ctrl.ancestors()[2], level]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + level['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.rooms = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.equipmentRecords = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.map(isLocationOfEdge => isLocationOfEdge.in) : [];
        ctrl.equipmentRecords.forEach(r => r.isEquipment = true);
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLevel(level); }, errorMessage: 'Unable to load level children for picker:' });
  }

  ctrl.navigateRoom = function (room) {
    ctrl.equipmentRecords = [];
    ctrl.startView = false;
    ctrl.actualLevel('Room');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], ctrl.ancestors()[2], ctrl.ancestors()[3], room]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + room['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.equipmentRecords = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.map(isLocationOfEdge => isLocationOfEdge.in) : [];
        ctrl.equipmentRecords.forEach(r => r.isEquipment = true);
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateRoom(room); }, errorMessage: 'Unable to load room children for picker:' });
  }

  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }
  ctrl.getLocations();
}

equipmentTree.onbeforeupdate = function (vnode) {
  var ctrl = this;
  ctrl.recordsToExclude = vnode.attrs.recordsToExclude || [];
  var selected = ctrl.selectedNode && ctrl.selectedNode();
  var selectedRid = selected && selected['@rid'] ? selected['@rid'] : selected;
  if (selectedRid && ctrl.recordsToExclude.indexOf(selectedRid) > -1) {
    ctrl.selectedNode('');
  }
}

equipmentTree.view = function (vnode) {
  var ctrl = this;
  var stateView = pickerRequestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.startView) return m('div')
  return m('div.mb2', [
    m('label', 'Select location:'),
    m('br'),
    m("div.mb2.pb2.bb.bw1.b--mid-gray.near-white", [
      m('div.dib-ns.mr2', { label: 'Home', onclick: ctrl.getLocations }),
      function () {
        if (ctrl.ancestors) {
          return ctrl.ancestors().map(function (ancestor, idx) {
            return m('div.dib-ns.mr2.pointer', {
              class: ancestor['@class'] === ctrl.actualLevel() ? "active" : "blue",
              onclick: () => {
                if (ancestor['@class'] === 'Home') ctrl.getLocations();
                if (ancestor['@class'] === 'Site') ctrl.navigateLocation(ancestor);
                if (ancestor['@class'] === 'Building') ctrl.navigateBuilding(ancestor);
              }
            }, [
              ancestor.name,
              ' / '
            ])
          })
        }
      }()
    ]),
    (() => {
      if (ctrl.actualLevel() === 'Home') {
        return m(paginationWithSearch, {
          data: [...ctrl.locations, ...ctrl.equipmentRecords],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            if(ctrl.recordsToExclude.indexOf(record['@rid']) > -1) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name,
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                record.isEquipment ?
                  ctrl.selectNode(record)
                :
                  (Array.isArray(record.out_isSiteOf) && record.out_isSiteOf.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                    ctrl.navigateLocation(record)
                  : 
                    ''
              }
            }, [
              record.isEquipment ?
                m('i', {
                  onclick: () => { ctrl.selectNode(record) },
                  class: 'fr f3 b ' +
                    (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
                })
              :
                (Array.isArray(record.out_isSiteOf) && record.out_isSiteOf.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b',
                    onclick: () => { ctrl.navigateLocation(record) }
                  })
                :
                  ''
            ]
            )
          })
        ])
      }
      if (ctrl.actualLevel() === 'Site') {
        return m(paginationWithSearch, {
          data: [...ctrl.buildings, ...ctrl.equipmentRecords],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            if(ctrl.recordsToExclude.indexOf(record['@rid']) > -1) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name,
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                record.isEquipment ?
                  ctrl.selectNode(record)
                :
                  (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                    ctrl.navigateBuilding(record)
                  : 
                    ''                
              }
            }, [
              record.isEquipment ?
                m('i', {
                  onclick: () => { ctrl.selectNode(record) },
                  class: 'fr f3 b ' +
                    (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
                })
              :
                (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b',
                    onclick: () => { ctrl.navigateBuilding(record) }
                  })
                :
                  ''
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Building') {
        return m(paginationWithSearch, {
          data: [...ctrl.floors, ...ctrl.equipmentRecords],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            if(ctrl.recordsToExclude.indexOf(record['@rid']) > -1) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name,
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                record.isEquipment ?
                  ctrl.selectNode(record)
                :
                  (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                    ctrl.navigateLevel(record)
                  : 
                    ''
              }
            }, [
              record.isEquipment ?
                m('i', {
                  onclick: () => { ctrl.selectNode(record) },
                  class: 'fr f3 b ' +
                    (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
                })
              :
                (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0 || Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b',
                    onclick: () => { ctrl.navigateLevel(record) }
                  })
                :
                  ''
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Level') {
        return m(paginationWithSearch, {
          data: [...ctrl.rooms, ...ctrl.equipmentRecords],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            if(ctrl.recordsToExclude.indexOf(record['@rid']) > -1) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                record.isEquipment ?
                  ctrl.selectNode(record)
                :
                  (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                    ctrl.navigateRoom(record)
                  : 
                    ''                
              }
            }, [
              record.isEquipment ?
                m('i', {
                  onclick: () => { ctrl.selectNode(record) },
                  class: 'fr f3 b ' +
                    (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
                })
              :
                (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b',
                    onclick: () => { ctrl.navigateRoom(record) }
                  })
                :
                  ''
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Room') {
        return m(paginationWithSearch, {
          data: [...ctrl.equipmentRecords],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            if(ctrl.recordsToExclude.indexOf(record['@rid']) > -1) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                  ctrl.selectNode(record)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(record) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
    })(),
  ])
}

module.exports = equipmentTree;
